/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PersonRelationInfo {
  cpf?: number;
  dateCreated?: Date;
  email?: string;
  firstName?: string;
  inviterCPF?: number;
  inviterEmail?: string;
  inviterName?: string;
  lastName?: string;
  name?: string;
  personId1?: number;
  personId2?: number;
  personRelationType?: string;
  personRelationTypeId?: number;
  subscriptionTypeId?: number;
  subscriptionTypeName?: string;
}
